module.exports = __webpack_public_path__ + "05_glasses_blue.487a822a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/05_glasses_blue.png
// module id = SNKf
// module chunks = 0